import React from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ExcelJS from "exceljs";
import axios from "axios";
import html2canvas from "html2canvas";

// import HSE_Cover_New from "../../HSE_Report_Cover.png";
// import HSE_Cover_New from "../../HSE PNG.png";
// import HSE_Cover_New from "../../HSEPortrait.png";
import HSE_Cover_New from "../../HSE2026_PNG.png";
// import Electrical_Cover_New from "../../Electrical_Safety_Report_Cover.png";
// import Electrical_Cover_New from "../../ElectricalPortrait.png";
import Electrical_Cover_New from "../../Electrical2026_PNG.png";
import logo from "../../mi_logo_report.png";

const ExportExcel = ({
  selectedOrganization,
  selectedSite,
  selectedState,
  selectedDateTime,
  backgroundBrief,
  improvementOpportunityAreas,
  overallAssessmentIndicator,
  contents,
  exeSummary,
  exeSummaryFindigs,
  exeSummaryKeyObservations,
  introduction,
  // gaugeImageWord,
  conclusion,
  criticalObservations,
  selectedObservations,
  isSaved,
  scores,
  cumulativeScore,
  otherDetails,
  reportType,
  ReportUID,
  bestPractice,
  theWayForward,
  startDate,
  endDate,
  name,
  facilityInfo,
  timeFrom,
  timeTo,
  briefPropertyDescription,
  numOfFloors,
  avgStaffFootfall,
  noObjectionCertificate,
  nationalBuildingCodeCategory,
  coordinationgPersonClientside,
  reportPreparedBy,
  reportReviewedBy,
  buildingName,
  classificationOfAuditObservations,
  auditScoreAnalysis,
  references,
  chartImage,
  scorePercent = 0
}) => {

  const imageToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.log("Error:", error.message)
    }
  };

  //  console.log("startdate",startDate);
  const generateCoverImage = async (client, location, date, reportType) => {
    const year = new Date().getFullYear();
    let service =
      reportType === "HSE"
        ? "HSE Audit"
        : "Electrical Audit";
    const container = document.createElement("div");
    container.style.width = "1192x"; // A4 width
    container.style.height = "1684px"; // A4 height
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.background = "#fff";
    // container.innerHTML = `
    //   <div style="position:relative; text-align:left; width:100%; height:100%;">
    //     <div style="width:100%; height:100%; position:relative;">
    //       <img src="${reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}" 
    //            style="width:100%; height:100%;" />
    //     </div>
    //     <div style="position:absolute; top:40%; width:65%; background-color:#efc71d; 
    //         clip-path: polygon(0% 0%, 100% 0%, 85% 100%, 0% 100%);
    //         padding:10px; box-sizing: border-box;">
    //       <p style="font-size:20px; color:#307268; margin:5px; border-bottom:1px solid #307268;">
    //         Client : ${client}
    //       </p>
    //       <p style="font-size:20px; color:#307268; margin:5px; border-bottom:1px solid #307268;">
    //         Location : ${location}
    //       </p>
    //       <p style="font-size:20px; color:#307268; margin:5px; border-bottom:1px solid #307268;">
    //         Service : ${service}
    //       </p>
    //       <p style="font-size:20px; color:#307268; margin:5px; border-bottom:1px solid #307268;">
    //         Date : ${date}
    //       </p>
    //       <a href="https://www.momentumindia.in" 
    //          style="color:#307268; margin:5px; font-size:13px; text-decoration:none;">
    //         www.momentumindia.in
    //       </a>
    //     </div>
    //     <div style="position:absolute; bottom:15%; left:20%; font-size:45px; font-weight:600; 
    //         font-family:'Montserrat', sans-serif; color:#f9f3d9;">
    //       ${reportType === "HSE" ? "HSE<br/>Report" : "Electrical<br/>Safety<br/>Report"}  
    //       <span style="display: flex; align-items: center; margin-top: 10px; font-size:25px; font-weight:normal">
    //         <span style="flex-grow: 1; height: 1px; background-color: #f9f3d9; margin-right: 10px;"></span>
    //         ${year}
    //       </span>
    //     </div>
    //     <div style="position:absolute; bottom:20px; left:20px; font-size:12px; color:#333;">
    //       Prepared by Momentum India
    //     </div>
    //   </div>
    // `;

    container.innerHTML = `
    <div style="width:100%; height:100%; position:relative;">
      <img src="${reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}" 
           style="width:100%; height:100%; object-fit:cover;" />

      <!-- Dynamic text placeholders -->
      <div style="position:absolute; top:888px; left:206px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${client || ""}
      </div>
       <div style="position:absolute; top:958px; left:245px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${location || ""}
      </div>
      <div style="position:absolute; top:1026px; left:216px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${service || ""}
      </div>
     
      <div style="position:absolute; top:1097px; left:185px; font-size:26px; font-family:Montserrat; color:#307268;">
      <!--  ${date || ""}-->
        ${startDate.getTime() === endDate.getTime()
        ? `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
        : `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate().toString().padStart(2, "0")}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`
        || ""}
      </div>
    </div>
  `;
    document.body.appendChild(container);
    const canvas = await html2canvas(container);
    const base64Image = canvas.toDataURL("image/png");
    document.body.removeChild(container);

    return base64Image;
  };

  const generateCoverImageForHSE = async (client, location, date, reportType) => {
    const year = new Date().getFullYear();
    let service =
      reportType === "HSE"
        ? "HSE Audit"
        : "Electrical Audit";
    const container = document.createElement("div");
    container.style.width = "1192x"; // A4 width
    container.style.height = "1684px"; // A4 height
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.background = "#fff";
    container.innerHTML = `
    <div style="width:100%; height:100%; position:relative;">
      <img src="${reportType === "HSE" ? HSE_Cover_New : Electrical_Cover_New}" 
           style="width:100%; height:100%; object-fit:cover;" />

      <!-- Dynamic text placeholders -->
      <div style="position:absolute; top:888px; left:206px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${client || ""}
      </div>
       <div style="position:absolute; top:958px; left:245px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${location || ""}
      </div>
      <div style="position:absolute; top:1026px; left:216px; font-size:28px; font-family:Montserrat; color:#307268;">
        ${service || ""}
      </div>
     
      <div style="position:absolute; top:1097px; left:185px; font-size:26px; font-family:Montserrat; color:#307268;">
      <!--  ${date || ""}-->
        ${startDate.getTime() === endDate.getTime()
        ? `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
        : `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate().toString().padStart(2, "0")}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`
        || ""}
      </div>
    </div>
  `;
    document.body.appendChild(container);
    const canvas = await html2canvas(container);
    const base64Image = canvas.toDataURL("image/png");
    document.body.removeChild(container);

    return base64Image;
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    const base64Image = await generateCoverImage(
      selectedOrganization?.label,
      selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label,

      selectedDateTime,
      reportType
    );


    const base64ImageforHSE = await generateCoverImageForHSE(
      selectedOrganization?.label,
      selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label,

      selectedDateTime,
      reportType
    );

    const base64logo = await imageToBase64(logo);

    const logoImg = workbook.addImage({
      base64: base64logo,
      extension: "png",
    });
    
    // const base64MiLogo = 
    // Create "Cover" sheet
    // cover page for electrical
    if (reportType != "HSE") {
      const coverSheet = workbook.addWorksheet("Cover Page");

      // Add image
      const imageId = workbook.addImage({
        base64: base64Image,
        extension: "png",
      });

      coverSheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        // ext: { width: 850, height: 1123 }, 
        // ext: { width: 800, height: 1684 }, 
        ext: { width: 700, height: 1000 },
      });

    }

    //cover page for HSE
    if (reportType == "HSE") {
      const coverSheet = workbook.addWorksheet("Cover Page");

      // Add image
      const imageId = workbook.addImage({
        base64: base64ImageforHSE,
        extension: "png",
      });

      coverSheet.addImage(imageId, {
        tl: { col: 0, row: 0 },
        // ext: { width: 850, height: 1123 }, 
        ext: { width: 700, height: 1000 },
      });

    }

    const getDaySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };


    if (reportType != "HSE") {
      const formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
      };
      const dateText =
        startDate.getTime() === endDate.getTime()
          ? formatDate(startDate)
          : `${formatDate(startDate)} to ${formatDate(endDate)}`;

      const historyWorksheet = workbook.addWorksheet("Document History");

      historyWorksheet.addRow([]).height = 60; // empty row to adjust MI logo
      historyWorksheet.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });

      const docHeader = historyWorksheet.addRow(["PARTICULARS", "DETAILS"]);
      docHeader.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "EFC71D" },
        };
        cell.font = {
          color: { argb: "000000" },
          bold: true,
        };
        // cell.alignment = { vertical: "middle", horizontal: "center" }; 
      });
      historyWorksheet.getColumn(1).width = 30;
      historyWorksheet.getColumn(2).width = 25;
      historyWorksheet.addRow([
        "Date of Visit",
        // startDate.getTime() === endDate.getTime()
        //   ? `${startDate.getDate()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
        //   : `${startDate.getDate()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`
        //  `${startDate.getDate()}${getDaySuffix(startDate.getDate())} ${startDate.toLocaleString("en-US", { month: "short" })} ${startDate.getFullYear()}`
        dateText
      ]);
      historyWorksheet.addRow(["Document Prepared By", name]);
      historyWorksheet.addRow(["Date of Document Submission", selectedDateTime.split("-").reverse().join("-")]);
      // historyWorksheet.addRow(["Document Version", ""]); // Add document version if available
    }

    // Create a worksheet for the main  data
    const reportWorksheet = workbook.addWorksheet("Report");
    reportWorksheet.addRow([]).height = 60; // empty row to adjust MI logo
    reportWorksheet.addImage(logoImg, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 60 },
    });
    const stripHtml = (html) => {
      if (!html) return "";
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent.replace(/\n\s*\n/g, "\n").trim();
    };
    const htmlToRichText = (html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const rawResult = [];

      const traverse = (node, baseStyle = {}, listContext = null) => {
        if (node.nodeType === Node.TEXT_NODE) {
          if (node.nodeValue.trim() !== "") {
            rawResult.push({ text: node.nodeValue, font: { ...baseStyle } });
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const newStyle = { ...baseStyle };

          if (node.tagName === "B" || node.tagName === "STRONG") newStyle.bold = true;
          if (node.tagName === "I" || node.tagName === "EM") newStyle.italic = true;
          if (node.tagName === "U") newStyle.underline = true;

          if (node.tagName === "UL") {
            for (let child of node.children) {
              traverse(child, newStyle, { type: "ul" });
            }
          } else if (node.tagName === "OL") {
            let index = 1;
            for (let child of node.children) {
              traverse(child, newStyle, { type: "ol", index: index++ });
            }
          } else if (node.tagName === "LI") {
            const prefix =
              listContext?.type === "ul"
                ? "• "
                : listContext?.type === "ol"
                  ? `${listContext.index}. `
                  : "";

            rawResult.push({ text: prefix, font: { ...baseStyle } });

            for (let child of node.childNodes) {
              traverse(child, newStyle);
            }

            rawResult.push({ text: "\n", font: {} }); // line break after list item
          } else if (node.tagName === "BR") {
            rawResult.push({ text: "\n", font: {} });
          } else if (node.tagName === "P") {
            for (let child of node.childNodes) {
              traverse(child, newStyle);
            }
            rawResult.push({ text: "\n", font: {} }); // line break after paragraph
          } else {
            for (let child of node.childNodes) {
              traverse(child, newStyle, listContext);
            }
          }
        }
      };

      for (let child of doc.body.childNodes) {
        traverse(child);
      }

      //  Normalize double newlines into single newlines
      const result = [];
      let prevWasNewline = false;
      for (const part of rawResult) {
        if (part.text === "\n") {
          if (!prevWasNewline) {
            result.push(part);
            prevWasNewline = true;
          }
        } else {
          result.push(part);
          prevWasNewline = false;
        }
      }

      return result;
    };


    const addFormattedRow = (worksheet, label, htmlContent) => {
      const row = worksheet.addRow([label, ""]); // Empty cell, we'll set richText manually
      const richText = htmlToRichText(htmlContent);

      row.getCell(1).alignment = { wrapText: true, vertical: "top" };
      row.getCell(2).value = { richText };
      row.getCell(2).alignment = { wrapText: true, vertical: "top" };
      row.height = 80;
    };

    // Shared audit disclaimer — same wording used in the Word and PDF exports
    // (ExportWordDoc.js / ExportSavedReportPDF.js) for both Electrical and HSE.
    const disclaimer = `This report is based on information provided and observations made during the audit. It is for informational purposes only and does not guarantee complete compliance or absolute safety. The organization is responsible for implementing corrective measures suggested in the audit report. By using this information, you agree that Momentum shall not be held responsible for any untoward events.`;

    // for electrical
    if (reportType != "HSE") {
      reportWorksheet.addRow([
        "Client",
        selectedOrganization ? selectedOrganization.label : "",
      ]);
      reportWorksheet.getColumn(1).width = 40;
      reportWorksheet.getColumn(2).width = 120;
      const addWrappedRow = (worksheet, label, content) => {
        const row = worksheet.addRow([label, stripHtml(content)]);
        row.getCell(2).alignment = { wrapText: true, vertical: "top" };
        row.height = 80; // optional: manually set row height for visibility
      };
      // addFormattedRow(reportWorksheet, "Date", selectedDateTime ? selectedDateTime.split("-").reverse().join("-") : "");
      addFormattedRow(reportWorksheet, "Location", selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label);
      // addFormattedRow(reportWorksheet, "Service", "Electrical Audit");
      if (reportType === "HSE") {
        addFormattedRow(reportWorksheet, "Service", "HSE Audit")
      }
      if (reportType !== "HSE") {
        addFormattedRow(reportWorksheet, "Service", "Electrical Audit")
      }
      // addFormattedRow(reportWorksheet, "Date", selectedDateTime ? selectedDateTime.split("-").reverse().join("-") : "");
      addFormattedRow(reportWorksheet, "Date", startDate.getTime() === endDate.getTime()
        ? `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}`
        : `${startDate.getDate().toString().padStart(2, "0")}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()} to ${endDate.getDate().toString().padStart(2, "0")}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}`

      );
      // addWrappedRow(reportWorksheet, "Background Brief", backgroundBrief);
      addFormattedRow(reportWorksheet, "Background - Project Brief", backgroundBrief);
      // Disclaimer sits immediately after Background - Project Brief (parity with Word/PDF).
      addFormattedRow(reportWorksheet, "Disclaimer", `<i>${disclaimer}</i>`);
      // addWrappedRow(reportWorksheet, "Contents", contents);
      addFormattedRow(reportWorksheet, "Understanding The Report", contents);
      if (reportType === "HSE") {
        addFormattedRow(reportWorksheet, "Introduction", introduction)
      }
      // addWrappedRow(reportWorksheet, "Executive Summary", exeSummary);
      addFormattedRow(reportWorksheet, "Executive Summary", exeSummary);
      // addFormattedRow(reportWorksheet, "Findings", exeSummaryFindigs)
      // addFormattedRow(reportWorksheet, "Key Observations", exeSummaryKeyObservations);

      addFormattedRow(reportWorksheet, "Improvement Opportunity Areas", improvementOpportunityAreas);
      {
        // Risk band mirrors ExportWordDoc.js / ExportSavedReportPDF.js so the
        // label reads "Overall Risk Assessment Indicator (84% — High Risk)".
        const _oaiScore = Math.floor((cumulativeScore / 25) * 100);
        const _oaiRiskLabel =
          _oaiScore >= 85 ? "Low Risk"
            : _oaiScore >= 65 ? "Medium Risk"
              : _oaiScore >= 25 ? "High Risk"
                : "Severe Risk";
        addFormattedRow(
          reportWorksheet,
          `Overall Risk Assessment Indicator (${_oaiScore}% — ${_oaiRiskLabel})`,
          overallAssessmentIndicator
        );
      }
      if (reportType === "HSE") {
        addFormattedRow(reportWorksheet, "Global Best Practices", bestPractice);

      }
      // addWrappedRow(reportWorksheet, "The Way Forward", theWayForward);
      addFormattedRow(reportWorksheet, "Way Forward Plan", theWayForward);
      // addWrappedRow(reportWorksheet, "Conclusion", conclusion);
      addFormattedRow(reportWorksheet, "Conclusion", conclusion);
    }

    // for hse dashboard — mirrors the "Dashboard" page rendered in
    // ExportSavedReportPDF.js and ExportWordDoc.js. Sheet sits between
    // "Report" and "Audit Description" so the tab order matches the
    // narrative order of the PDF/Word exports. Skip silently when there's
    // no chartImage (parity with the PDF behaviour, see ODT-12/13 notes).
    if (reportType === "HSE" && chartImage) {
      const dashboardSheet = workbook.addWorksheet("Dashboard");
      dashboardSheet.addRow([]).height = 60; // empty row to adjust MI logo
      dashboardSheet.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      

      // Five 20-unit columns give us a printable A4-portrait-ish canvas
      // for the chart image.
      dashboardSheet.columns = [
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];

      // Heading row — matches the Word doc "Dashboard" title styling
      // (Montserrat, bold, #307268). 5.6:1 contrast on white → WCAG AA.
      dashboardSheet.mergeCells("A2:E2");
      const headingCell = dashboardSheet.getCell("A2");
      headingCell.value = "Dashboard";
      headingCell.font = {
        name: "Montserrat",
        size: 18,
        bold: true,
        color: { argb: "FF307268" },
      };
      headingCell.alignment = { vertical: "middle", horizontal: "center" };
      dashboardSheet.getRow(2).height = 28;

      // Read true PNG dimensions from the IHDR chunk so the embedded
      // image keeps its natural aspect ratio (lifted from
      // ExportWordDoc.js so PDF/Word/Excel stay visually consistent).
      const computeChartSize = (dataUrl) => {
        const MAX_W = 720; // A4 portrait content width @96dpi
        const MAX_H = 820; // keep chart on one page
        let w = MAX_W;
        let h = Math.round(MAX_W / 0.947); // fallback ratio
        try {
          const b64 = (dataUrl || "").split(",")[1] || "";
          const bin = atob(b64.slice(0, 64));
          const u32 = (i) =>
            ((bin.charCodeAt(i) << 24) |
              (bin.charCodeAt(i + 1) << 16) |
              (bin.charCodeAt(i + 2) << 8) |
              bin.charCodeAt(i + 3)) >>> 0;
          const nw = u32(16); // PNG IHDR width
          const nh = u32(20); // PNG IHDR height
          if (nw > 0 && nh > 0) {
            const ratio = nh / nw;
            w = MAX_W;
            h = Math.round(MAX_W * ratio);
            if (h > MAX_H) {
              h = MAX_H;
              w = Math.round(MAX_H / ratio);
            }
          }
        } catch (e) {
          // fall back to defaults above
        }
        return { width: w, height: h };
      };

      const base64Payload = chartImage.includes(",")
        ? chartImage.split(",")[1]
        : chartImage;
      const chartImageId = workbook.addImage({
        base64: base64Payload,
        extension: "png",
        // exceljs surfaces `name` on <xdr:cNvPr>; best-effort alt-text
        // handle for the embedded chart.
        name: "HSE audit dashboard chart",
      });

      const { width: imgW, height: imgH } = computeChartSize(chartImage);
      dashboardSheet.addImage(chartImageId, {
        tl: { col: 0, row: 3 },
        ext: { width: imgW, height: imgH },
        editAs: "oneCell",
      });

      dashboardSheet.pageSetup = {
        paperSize: 9, // A4
        orientation: "portrait",
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 1,
        margins: {
          left: 0.4,
          right: 0.4,
          top: 0.4,
          bottom: 0.4,
          header: 0.2,
          footer: 0.2,
        },
      };
    }

    // for hse audit description
    if (reportType == "HSE") {
      const auditDescription = workbook.addWorksheet("Audit Description");
      auditDescription.addRow([]).height = 60; // empty row to adjust MI logo
      auditDescription.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });

      // Define column widths for neat alignment
      auditDescription.columns = [
        { width: 40 },
        { width: 50 },
      ];

      // Add rows one by one
      // auditDescription.addRows([
      //   ["Client", selectedOrganization?.label || "N/A"],
      //   ["Location", selectedSite?.label || "N/A"],
      //   [
      //     "Date of Site Visit",
      //     startDate
      //       ? `${startDate.getDate()}-${startDate.getMonth() + 1}-${startDate.getFullYear()}`
      //       : "N/A",
      //   ],
      //   ["Study", "HSE Audit Report"],
      //   [
      //     "Time of Audit (From & To)",
      //     (timeFrom && timeTo
      //       ? `${timeFrom} to ${timeTo}`
      //       : timeFrom
      //       ? `${timeFrom} to N/A`
      //       : timeTo
      //       ? `N/A to ${timeTo}`
      //       : "N/A")+(" (Date wise breakup)"),
      //   ],
      //   ["Brief Property Description", briefPropertyDescription || "N/A"],
      //   ["Number of Floors", numOfFloors || "N/A"],
      //   ["Average Staff Footfall", avgStaffFootfall || "N/A"],
      //   ["No Objection Certificate:", noObjectionCertificate || "N/A"],
      //   ["National Building Code Category", nationalBuildingCodeCategory || "N/A"],
      //   ["Coordinating Person – Client Side", coordinationgPersonClientside || "N/A"],
      //   ["Report Prepared By", reportPreparedBy || "N/A"],
      //   ["Report Reviewed By", reportReviewedBy || "N/A"],
      //   [
      //     "Date of Submission of Report",
      //     endDate
      //       ? `${endDate.getDate()}-${endDate.getMonth() + 1}-${endDate.getFullYear()}`
      //       : "N/A",
      //   ],
      // ]);

      const rows = [
        ["Client", selectedOrganization?.label || "N/A"],
        ["Location", selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label || "N/A"],
        [
          "Date of Site Visit",
          startDate
            ? `${String(startDate.getDate()).padStart(2, '0')}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${startDate.getFullYear()}`
            : "N/A",
        ],
        ["Study", "HSE Audit Report"],

      ];
      if (timeFrom || timeTo) {
        rows.push([
          "Time of Audit (From & To)",
          (timeFrom && timeTo
            ? `${timeFrom} to ${timeTo}`
            : timeFrom
              ? `${timeFrom} to N/A`
              : timeTo
                ? `N/A to ${timeTo}`
                : "N/A") + " (Date wise breakup)",
        ])
      }
      if (briefPropertyDescription) {
        rows.push(["Brief Property Description", briefPropertyDescription]);
      }
      if (numOfFloors) {
        rows.push(["Number of Floors", numOfFloors || "N/A"])
      }
      if (avgStaffFootfall) {
        rows.push(["Average Staff Footfall", avgStaffFootfall || "N/A"])
      }
      if (noObjectionCertificate) {
        rows.push(["No Objection Certificate:", noObjectionCertificate || "N/A"])
      }
      if (nationalBuildingCodeCategory) {
        rows.push(["National Building Code Category", nationalBuildingCodeCategory || "N/A"])
      }
      if (coordinationgPersonClientside) {
        rows.push(["Coordinating Person – Client Side", coordinationgPersonClientside || "N/A"])
      }
      if (reportPreparedBy) {
        rows.push(["Report Prepared By", reportPreparedBy || "N/A"])
      }
      if (reportReviewedBy) {
        rows.push(["Report Reviewed By", reportReviewedBy || "N/A"])
      }
      if (buildingName) {
        rows.push(["Building Name", buildingName || "N/A"])
      }
      rows.push(
        [
          "Date of Submission of Report",
          endDate
            ? `${String(endDate.getDate()).padStart(2, '0')}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${endDate.getFullYear()}`
            : "N/A",
        ]
      );

      auditDescription.addRows(rows);


      // Optional: Add bold styling for header
      // auditDescription.getRow(1).font = { bold: true };

      auditDescription.getColumn(1).eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF8DC' },
        }
      })
      // Add borders and alignment for all cells
      auditDescription.eachRow((row, rowNumber) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", wrapText: true };
        });
      });

    }

    // for hse report
    if (reportType == "HSE") {
      reportWorksheet.addRow([
        "Client",
        selectedOrganization ? selectedOrganization.label : "",
      ]);
      reportWorksheet.getColumn(1).width = 40;
      reportWorksheet.getColumn(2).width = 120;
      const addWrappedRow = (worksheet, label, content) => {
        const row = worksheet.addRow([label, stripHtml(content)]);
        row.getCell(2).alignment = { wrapText: true, vertical: "top" };
        row.height = 80; // optional: manually set row height for visibility
      };
      // addFormattedRow(reportWorksheet, "Date", selectedDateTime ? selectedDateTime.split("-").reverse().join("-") : "");
      addFormattedRow(reportWorksheet, "Location", selectedState && selectedState?.label != null  ? selectedSite.label+", "+selectedState.label:selectedSite?.label);
      // addFormattedRow(reportWorksheet, "Service", "Electrical Audit");
      if (reportType === "HSE") {
        addFormattedRow(reportWorksheet, "Service", "HSE Audit")
      }
      addFormattedRow(reportWorksheet, "Date", selectedDateTime ? selectedDateTime.split("-").reverse().join("-") : "");
      addFormattedRow(reportWorksheet, "Understanding The Report", contents);
      // Disclaimer sits immediately after Understanding The Report (parity with Word/PDF).
      addFormattedRow(reportWorksheet, "Disclaimer", `<i>${disclaimer}</i>`);
      addFormattedRow(reportWorksheet, "Classification of Audit Observations", classificationOfAuditObservations);
      addFormattedRow(reportWorksheet, "Audit Objective", backgroundBrief);
      addFormattedRow(reportWorksheet, "Executive Summary", exeSummary);
      addFormattedRow(reportWorksheet, "Findings", exeSummaryFindigs);
      addFormattedRow(reportWorksheet, "Key Observations", exeSummaryKeyObservations);

      addFormattedRow(reportWorksheet, "Audit Score Analysis", auditScoreAnalysis);
      addFormattedRow(reportWorksheet, "Improvement Opportunity Areas", improvementOpportunityAreas);
      // for hse
      if (reportType === "HSE") {
        // Risk band mirrors ExportWordDoc.js / ExportSavedReportPDF.js so the
        // Excel label reads "Overall Assessment Indicator (85% — Low Risk)".
        const _score = Number(scorePercent) || 0;
        const _riskLabel =
          _score >= 85 ? "Low Risk"
            : _score >= 65 ? "Medium Risk"
              : _score >= 25 ? "High Risk"
                : "Severe Risk";
        addFormattedRow(
          reportWorksheet,
          `Overall Assessment Indicator (${_score}% — ${_riskLabel})`,
          overallAssessmentIndicator
        );
      }

      addFormattedRow(reportWorksheet, "Conclusion", conclusion);

    }
    //observations table
    async function fetchImageBuffer(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();
      return new Uint8Array(arrayBuffer);
    }
    // for HSE obs
    if (reportType === "HSE") {
      const ObservationsandRecommendations = workbook.addWorksheet("Observations & Recommendations");
      ObservationsandRecommendations.addRow([]).height = 60; // empty row to adjust MI logo
      ObservationsandRecommendations.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      const photoSheet = workbook.addWorksheet("Photos");
      photoSheet.addRow([]).height = 60; // empty row to adjust MI logo
      photoSheet.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      const headerRow = ObservationsandRecommendations.addRow([
        "Sr. No.",
        "Area / Process",
        "Equipment",
        "Category",
        // "Check Point",
        "Criticality",
        "Status",
        "Observation",
        "Recommendation",
        "Legal Reference (if any)",
        "Score",
        "Objective Evidence",
        
        // "Score",
        // "System Implementation",
        // "Compliance Check",
        
      ]);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "307268" }, // background
        };
        cell.font = {
          bold: true,
          color: { argb: "EFC71D" }, // text color
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      });

      let photoSheetRowPointer = 2;
      for (let i = 0; i < selectedObservations.length; i++) {
        const obs = selectedObservations[i];
        const imageUrls = obs.imageUrls || [];

        const viewAllLink = imageUrls.length
          ? { text: "[View All]", hyperlink: `#Photos!A${photoSheetRowPointer + 1}` }
          : "NA";

        const row = ObservationsandRecommendations.addRow([
          i + 2,
          obs.area || "N/A",
          obs.equipment || "N/A",
          obs.category || "N/A",
          // obs.check_points || "N/A",
          obs.criticality || "N/A",
          obs.status || "N/A",
          obs.observation || "N/A",
          obs.recommendations || "N/A",
          obs.legal_reference || "N/A",
          obs.score || 0,
          viewAllLink,
          
          // obs.score || "N/A",
          // obs.system_implementation||"N/A",
          // obs.compliance_check||"N/A",
        
        ]);
        ObservationsandRecommendations.getRow(row.number).height = 90;

        row.eachCell((cell, colNumber) => {
          cell.alignment = {
            wrapText: true,
            vertical: "middle",
            horizontal: "center",
          };
        });

        if (imageUrls.length > 0) {
          const anchorCell = photoSheet.getCell(`A${photoSheetRowPointer}`);
          anchorCell.value = `Observation ${i + 1}`;
          anchorCell.font = { bold: true };
          photoSheetRowPointer++;

          for (let j = 0; j < imageUrls.length; j++) {
            try {
              const imageBuffer = await fetchImageBuffer(imageUrls[j]);
              const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: "jpeg",
              });

              photoSheet.addImage(imageId, {
                tl: { col: j * 3, row: photoSheetRowPointer - 1 },
                ext: { width: 150, height: 100 },
                editAs: "oneCell",
              });
            } catch (error) {
              console.error(`Image load failed: ${imageUrls[j]}`, error);
            }
          }

          photoSheetRowPointer += 6; // Space before next group
        }
      }

      ObservationsandRecommendations.columns.forEach((col, index) => {
        if (index === 0 ) {
          col.width = 10;
        } else if (index === 4 || index === 5 || index === 9){
            // Criticality (4), Status (5) and Score (9) are short values, kept narrow
            // at width 15. Observation (index 6) falls through to the 25 default so it
            // matches the Recommendation column width.
            col.width = 15;
        } else {
          col.width = 25;
        }
      });

    }

    // For electrical
    if (reportType !== "HSE") {
      const ObservationsandRecommendations = workbook.addWorksheet("Observations & Recommendations");
      ObservationsandRecommendations.addRow([]).height = 60; // empty row to adjust MI logo
      ObservationsandRecommendations.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      const photoSheet = workbook.addWorksheet("Photos");
      photoSheet.addRow([]).height = 60; // empty row to adjust MI logo
      photoSheet.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      const headerRow = ObservationsandRecommendations.addRow([
        "Sr. No",
        "Area",
        "Observation",
        "Criticality",
        "Recommendations",
        "Is Reference",
        "Photo Evidence",
      ]);
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "307268" }, // background
        };
        cell.font = {
          bold: true,
          color: { argb: "EFC71D" }, // text color
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      });

      let photoSheetRowPointer = 1;
      for (let i = 0; i < selectedObservations.length; i++) {
        const obs = selectedObservations[i];
        const imageUrls = obs.imageUrls || [];

        const viewAllLink = imageUrls.length
          ? { text: "[View All]", hyperlink: `#Photos!A${photoSheetRowPointer + 1}` }
          : "NA";

        const row = ObservationsandRecommendations.addRow([
          i + 1,
          obs.area || "N/A",
          obs.observation || "N/A",
          obs.criticality || "N/A",
          obs.recommendations || "N/A",
          obs.is_reference || "N/A",
          viewAllLink,
        ]);
        ObservationsandRecommendations.getRow(row.number).height = 90;

        row.eachCell((cell, colNumber) => {
          cell.alignment = {
            wrapText: true,
            vertical: "middle",
            // horizontal: "center",
            horizontal: [2, 3, 5].includes(colNumber) ? "left" : "center",
          };
        });

        if (imageUrls.length > 0) {
          const anchorCell = photoSheet.getCell(`A${photoSheetRowPointer}`);
          anchorCell.value = `Observation ${i + 1}`;
          anchorCell.font = { bold: true };
          photoSheetRowPointer++;

          for (let j = 0; j < imageUrls.length; j++) {
            try {
              const imageBuffer = await fetchImageBuffer(imageUrls[j]);
              const imageId = workbook.addImage({
                buffer: imageBuffer,
                extension: "jpeg",
              });

              photoSheet.addImage(imageId, {
                tl: { col: j * 3, row: photoSheetRowPointer - 1 },
                ext: { width: 150, height: 100 },
                editAs: "oneCell",
              });
            } catch (error) {
              console.error(`Image load failed: ${imageUrls[j]}`, error);
            }
          }
          photoSheetRowPointer += 6; // Space before next group
        }
      }

      ObservationsandRecommendations.columns.forEach((col, index) => {
        if (index === 0 || index === 3) {
          col.width = 10;
        } else {
          col.width = 25;
        }
      });
    }

    // if (reportType !== "HSE") {
    //   const scoresWorksheet = workbook.addWorksheet("Scoring Table");


    //   const tableATitle = scoresWorksheet.addRow(["Scoring Table"]);

    //   tableATitle.getCell(1).font = { bold: true, size: 14,color: { argb: "307268" }, };
    //   scoresWorksheet.addRow([]); // empty row after Table A title


    //   const headerRow = scoresWorksheet.addRow([
    //     "Parameter",
    //     "Max Score",
    //     "Score Obtained",
    //   ]);

    //   headerRow.eachCell((cell) => {
    //     cell.fill = {
    //       type: "pattern",
    //       pattern: "solid",
    //       fgColor: { argb: "307268" }, // green background
    //     };
    //     cell.font = {
    //       color: { argb: "EFC71D" }, // yellow text
    //       bold: true,
    //     };
    //     cell.alignment = { vertical: "middle", horizontal: "center" };
    //     cell.border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };
    //   });

    //   // Add rows for scores
    //   scores.forEach((row) => {
    //     const dataRow = scoresWorksheet.addRow([
    //       row["Electrical Safety"],
    //       row["Maximum Score"],
    //       row["Score Obtained"],
    //     ]);

    //     dataRow.eachCell((cell) => {
    //       cell.alignment = { vertical: "middle", horizontal: "center" };
    //       cell.border = {
    //         top: { style: "thin" },
    //         left: { style: "thin" },
    //         bottom: { style: "thin" },
    //         right: { style: "thin" },
    //       };
    //     });
    //   });

    //   scoresWorksheet.getColumn(1).width = 28;
    //   scoresWorksheet.getColumn(2).width = 10;
    //   scoresWorksheet.getColumn(3).width = 15;

    //   const cumulativeRow = scoresWorksheet.addRow([
    //     "Cumulative",
    //     25,
    //     cumulativeScore,
    //   ]);

    //   cumulativeRow.eachCell((cell) => {
    //     cell.fill = {
    //       type: "pattern",
    //       pattern: "solid",
    //       fgColor: { argb: "EFC71D" }, 
    //     };
    //     cell.font = {
    //       color: { argb: "000000" }, 
    //       bold: true,
    //     };
    //     cell.alignment = { vertical: "middle", horizontal: "center" };
    //     cell.border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };
    //   });

    //   const percentage = Math.floor((cumulativeScore / 25) * 100) + "%";
    //   scoresWorksheet.addRow([]);
    //   scoresWorksheet.addRow([]);
    //  const percentageRow = scoresWorksheet.addRow(["Overall Score", percentage]);

    // percentageRow.eachCell((cell) => {
    //   cell.alignment = { vertical: "middle", horizontal: "center" }; 
    //   cell.font = { bold: true, size: 14 }; 
    // });



    //   const tableBTitle = scoresWorksheet.getRow(1); 
    //   tableBTitle.getCell(5).value = "Risk Legend";
    //   tableBTitle.getCell(5).font = { bold: true, size: 14,color:{argb:"307268"} };

    //   const emptyRowForTableB = scoresWorksheet.getRow(2);
    //   emptyRowForTableB.getCell(5).value = ""; 


    //   const riskLevels = [
    //     {
    //       range: "≥ 85%",
    //       risk: "Low Risk",
    //       color: "00A651",
    //       interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
    //     },
    //     {
    //       range: "65% – 84%",
    //       risk: "Medium Risk",
    //       color: "FFFF00",
    //       interpretation: "Controls are adequate but with noticeable weaknesses.",
    //     },
    //     {
    //       range: "25% – 64%",
    //       risk: "High Risk",
    //       color: "FFA500",
    //       interpretation: "High vulnerabilities with major compliance gaps.",
    //     },
    //     {
    //       range: "< 25%",
    //       risk: "Severe Risk",
    //       color: "FF0000",
    //       interpretation: "Controls are ineffective, urgent corrective action required.",
    //     },
    //   ];


    //   const legendHeader = scoresWorksheet.getRow(3);
    //   legendHeader.getCell(5).value = "Score Range";
    //   legendHeader.getCell(6).value = "Risk Level";
    //   legendHeader.getCell(7).value = "Interpretation";

    //   [5, 6, 7].forEach((col) => {
    //     const cell = legendHeader.getCell(col);
    //     cell.fill = {
    //       type: "pattern",
    //       pattern: "solid",
    //       fgColor: { argb: "307268" }, // dark green
    //     };
    //     cell.font = { color: { argb: "EFC71D" }, bold: true };
    //     cell.alignment = { vertical: "middle", horizontal: "center" };
    //     cell.border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };
    //   });

    //   riskLevels.forEach((level, index) => {
    //     const row = scoresWorksheet.getRow(index + 4); // start from row 4

    //     row.getCell(5).value = level.range;
    //     row.getCell(5).font = { color: { argb: level.color }, bold: true };
    //     row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };
    //     row.getCell(5).border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };

    //     row.getCell(6).value = level.risk;
    //     row.getCell(6).fill = {
    //       type: "pattern",
    //       pattern: "solid",
    //       fgColor: { argb: level.color },
    //     };
    //     row.getCell(6).font = { color: { argb: "000000" } }; // black text
    //     row.getCell(6).alignment = { horizontal: "center", vertical: "middle" };
    //     row.getCell(6).border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };

    //     row.getCell(7).value = level.interpretation;
    //     row.getCell(7).alignment = { wrapText: true };
    //     row.getCell(7).border = {
    //       top: { style: "thin" },
    //       left: { style: "thin" },
    //       bottom: { style: "thin" },
    //       right: { style: "thin" },
    //     };
    //   });

    //   scoresWorksheet.getColumn(5).width = 12;
    //   scoresWorksheet.getColumn(6).width = 15;
    //   scoresWorksheet.getColumn(7).width = 60;



    // }
    if (reportType !== "HSE") {
      const scoresWorksheet = workbook.addWorksheet("Scoring Table");
      scoresWorksheet.addRow([]).height = 60; // empty row to adjust MI logo
      scoresWorksheet.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });

      const tableATitle = scoresWorksheet.addRow(["Scoring Table"]);
      tableATitle.getCell(1).font = {
        bold: true,
        size: 14,
        color: { argb: "307268" }
      };

      scoresWorksheet.addRow([]); // Empty row

      const headerRow = scoresWorksheet.addRow([
        "Parameter",
        "Max Score",
        "Score Obtained",
      ]);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "307268" },
        };
        cell.font = { color: { argb: "EFC71D" }, bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });


      scores.forEach((row) => {
        const dataRow = scoresWorksheet.addRow([
          row.parameter,
          row.MaximumScore,
          row.ScoreObtained,
        ]);

        dataRow.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      scoresWorksheet.getColumn(1).width = 30;
      scoresWorksheet.getColumn(2).width = 12;
      scoresWorksheet.getColumn(3).width = 15;
      const cumulativeMax = scores.reduce((sum, r) => sum + r.MaximumScore, 0);
      const cumulativeObtained = scores.reduce((sum, r) => sum + r.ScoreObtained, 0);

      const cumulativeRow = scoresWorksheet.addRow([
        "Cumulative",
        cumulativeMax,
        cumulativeObtained.toFixed(2),
      ]);

      cumulativeRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "EFC71D" },
        };
        cell.font = { color: { argb: "000000" }, bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      const percentage = Math.floor((cumulativeObtained / cumulativeMax) * 100) + "%";

      scoresWorksheet.addRow([]);
      scoresWorksheet.addRow([]);

      const percentageRow = scoresWorksheet.addRow(["Overall Score", percentage]);

      percentageRow.eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { bold: true, size: 14 };
      });

      // Scoring bar chart, embedded beneath the Scoring Table under the
      // "Overall Score" row (see screenshot reference). Keeps parity with the
      // Electrical chart shown in ExportWordDoc.js / ExportSavedReportPDF.js.
      // Skipped silently when no chartImage was captured (same guard as the
      // HSE Dashboard sheet above).
      if (chartImage) {
        // Read natural PNG dimensions from the IHDR chunk so the chart keeps
        // its aspect ratio, capped to sit neatly under the 3-column table.
        // Mirrors the sizing helper used by the HSE Dashboard sheet.
        const computeChartSize = (dataUrl) => {
          const MAX_W = 480; // fits under the Parameter/Score columns
          const MAX_H = 300;
          let w = MAX_W;
          let h = Math.round(MAX_W / 1.857); // fallback ~ Word doc 650x350 ratio
          try {
            const b64 = (dataUrl || "").split(",")[1] || "";
            const bin = atob(b64.slice(0, 64));
            const u32 = (idx) =>
              ((bin.charCodeAt(idx) << 24) |
                (bin.charCodeAt(idx + 1) << 16) |
                (bin.charCodeAt(idx + 2) << 8) |
                bin.charCodeAt(idx + 3)) >>> 0;
            const nw = u32(16); // PNG IHDR width
            const nh = u32(20); // PNG IHDR height
            if (nw > 0 && nh > 0) {
              const ratio = nh / nw;
              w = MAX_W;
              h = Math.round(MAX_W * ratio);
              if (h > MAX_H) {
                h = MAX_H;
                w = Math.round(MAX_H / ratio);
              }
            }
          } catch (e) {
            // fall back to defaults above
          }
          return { width: w, height: h };
        };

        const base64Payload = chartImage.includes(",")
          ? chartImage.split(",")[1]
          : chartImage;
        const chartImageId = workbook.addImage({
          base64: base64Payload,
          extension: "png",
          // exceljs surfaces `name` on <xdr:cNvPr>; best-effort alt-text
          // handle for the embedded chart.
          name: "Electrical audit scoring chart",
        });

        const { width: imgW, height: imgH } = computeChartSize(chartImage);
        // One blank row below "Overall Score", then anchor at column A.
        scoresWorksheet.addImage(chartImageId, {
          tl: { col: 0, row: percentageRow.number + 1 },
          ext: { width: imgW, height: imgH },
          editAs: "oneCell",
        });
      }


      const tableBTitle = scoresWorksheet.getRow(2);
      tableBTitle.getCell(5).value = "Risk Legend";
      tableBTitle.getCell(5).font = { bold: true, size: 14, color: { argb: "307268" } };

      const emptyRowForTableB = scoresWorksheet.getRow(3);
      emptyRowForTableB.getCell(6).value = "";


      const riskLevels = [
        {
          range: "≥ 85%",
          risk: "Low Risk",
          color: "00A651",
          interpretation: "Electrical systems and controls are well maintained, only minor improvements needed.",
        },
        {
          range: "65% – 84%",
          risk: "Medium Risk",
          color: "FFFF00",
          interpretation: "Controls are adequate but with noticeable weaknesses.",
        },
        {
          range: "25% – 64%",
          risk: "High Risk",
          color: "FFA500",
          interpretation: "High vulnerabilities with major compliance gaps.",
        },
        {
          range: "< 25%",
          risk: "Severe Risk",
          color: "FF0000",
          interpretation: "Controls are ineffective, urgent corrective action required.",
        },
      ];


      const legendHeader = scoresWorksheet.getRow(4);
      legendHeader.getCell(5).value = "Score Range";
      legendHeader.getCell(6).value = "Risk Level";
      legendHeader.getCell(7).value = "Interpretation";

      [5, 6, 7].forEach((col) => {
        const cell = legendHeader.getCell(col);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "307268" }, // dark green
        };
        cell.font = { color: { argb: "EFC71D" }, bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      riskLevels.forEach((level, index) => {
        const row = scoresWorksheet.getRow(index + 5); // start from row 4

        row.getCell(5).value = level.range;
        row.getCell(5).font = { color: { argb: level.color }, bold: true };
        row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };
        row.getCell(5).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        row.getCell(6).value = level.risk;
        row.getCell(6).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: level.color },
        };
        row.getCell(6).font = { color: { argb: "000000" } }; // black text
        row.getCell(6).alignment = { horizontal: "center", vertical: "middle" };
        row.getCell(6).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        row.getCell(7).value = level.interpretation;
        row.getCell(7).alignment = { wrapText: true };
        row.getCell(7).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      scoresWorksheet.getColumn(5).width = 12;
      scoresWorksheet.getColumn(6).width = 15;
      scoresWorksheet.getColumn(7).width = 60;
    }

    //for hse annexure 
    if (reportType == "HSE") {
      const annexureTable = workbook.addWorksheet("Annexure Table");
      annexureTable.addRow([]).height = 60; // empty row to adjust MI logo
      annexureTable.addImage(logoImg, {
        tl: { col: 0, row: 0 },
        ext: { width: 200, height: 60 },
      });
      // // Define columns
      // annexureTable.columns = [
      //   { header: "Reference Type and Document / Standard", key: "document", width: 60 },
      //   { header: "Relevance to Audit Findings", key: "relevance", width: 60 },
      // ];

      const tableHeader = annexureTable.getRow(2);
      tableHeader.getCell(1).value = "Reference Type and Document / Standard";
      tableHeader.getCell(2).value = "Relevance to Audit Findings";
      
      annexureTable.getColumn(1).width = 60;
      annexureTable.getColumn(2).width = 60;

      // Start with a row counter to track dynamic insertion
      let currentRow = 3;

      // Add table header styling
      annexureTable.getRow(2).font = { bold: true, color: { argb: "FFFFFFFF" }, size: 14 };
      annexureTable.getRow(2).alignment = { horizontal: "center", vertical: "middle" };
      annexureTable.getRow(2).eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          // fgColor: { argb: "D9E1F2" }, // Light blue header background
          fgColor: { argb: "1E6255" },// Light blue header background
        };
      });

      // Loop through references data
      references.forEach((ref) => {
        if (ref.type === "heading") {
          // Add a merged row for section headings
          annexureTable.mergeCells(`A${currentRow}:B${currentRow}`);
          const cell = annexureTable.getCell(`A${currentRow}`);
          cell.value = ref.section_name || "Section";
          cell.font = { bold: true, size: 12 };
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF2CC" }, // Light yellow for section heading
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        } else {
          // Regular data rows
          annexureTable.addRow([
            ref.document || "N/A",
            ref.relevance || "N/A",
          ]);
        }
        currentRow++;
      });

      // Add borders and alignment for all regular rows
      annexureTable.eachRow((row, rowNumber) => {
        if (rowNumber === 2) return; // Skip header row (already styled)
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.alignment = { vertical: "middle", wrapText: true };
        });
      });

    }

    // Trigger the download
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${ReportUID}.xlsx`;
    a.click();
  };

  return (
    <div>
      <button
        onClick={exportToExcel}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          background: isSaved ? "#efc71d" : "lightgrey",
          borderStyle: "none",
          borderRadius: "5px",
          fontWeight: "bold",
          padding: "11px 18px",
          textTransform: "uppercase",
          color: "white",
          fontSize: "1rem",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.5)",
        }}
        disabled={!isSaved}
      >
        EXPORT TO EXCEL
        <FileDownloadIcon fontSize="small" style={{ marginLeft: "8px" }} />
      </button>
    </div>
  );
};

export default ExportExcel;








